import React from "react";
import { FaTimesCircle, FaCheckCircle, FaArrowRight } from "react-icons/fa";
import {
  SectionContainer,
  SectionContent,
  SectionHeader,
  SectionPreTitle,
  SectionSubTitle,
  SectionTitle,
} from "../../styles/global.syles";
import {
  LotteryContent,
  ComparisonGrid,
  ComparisonCard,
} from "./Lottery.styles";

const Lottery = () => {
  return (
    <SectionContainer id="features" bg="#f8fafd">
      <SectionContent>
        {/* Section header */}
        <SectionHeader>
          <SectionPreTitle>Counter Transformation</SectionPreTitle>
          <SectionTitle>Give Your Lottery Counter a Modern Facelift</SectionTitle>
          <SectionSubTitle>
            Free 100% of your retail counter space. Replace messy cardboard bins with a
            stunning 4K high-definition digital scratcher display that attracts more players.
          </SectionSubTitle>
        </SectionHeader>

        {/* Comparison Showcase */}
        <LotteryContent>
          <ComparisonGrid>
            {/* Before Card */}
            <ComparisonCard className="before-card">
              <div className="card-badge before-badge">
                <FaTimesCircle /> Before: Cluttered Counter
              </div>
              <div className="img-frame">
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/beyondlottotv.appspot.com/o/images%2Flottery-before.png?alt=media&token=a5ee2601-3fdd-47d5-855f-3b9d43842b21"
                  loading="lazy"
                  alt="Cluttered counter before Beyond Lottery"
                />
              </div>
              <div className="card-points">
                <div className="point-item negative">
                  <FaTimesCircle className="icon" />
                  <span>Messy counter space blocks customer checkout</span>
                </div>
                <div className="point-item negative">
                  <FaTimesCircle className="icon" />
                  <span>Hard for players to browse 50+ scratcher games</span>
                </div>
                <div className="point-item negative">
                  <FaTimesCircle className="icon" />
                  <span>No live prize or jackpot updates</span>
                </div>
              </div>
            </ComparisonCard>

            {/* After Card */}
            <ComparisonCard className="after-card">
              <div className="card-badge after-badge">
                <FaCheckCircle /> After: 4K Digital Display
              </div>
              <div className="img-frame">
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/beyondlottotv.appspot.com/o/images%2Flottery-after.png?alt=media&token=f8783bc8-746d-4271-a6b6-79dfbd295280"
                  loading="lazy"
                  alt="Clean counter after Beyond Lottery TV"
                />
              </div>
              <div className="card-points">
                <div className="point-item positive">
                  <FaCheckCircle className="icon" />
                  <span>100% counter space freed for high-margin impulse items</span>
                </div>
                <div className="point-item positive">
                  <FaCheckCircle className="icon" />
                  <span>Crystal-clear 4K scratcher board drives +35% sales</span>
                </div>
                <div className="point-item positive">
                  <FaCheckCircle className="icon" />
                  <span>Real-time jackpot alerts (Powerball & Mega Millions)</span>
                </div>
              </div>
            </ComparisonCard>
          </ComparisonGrid>
        </LotteryContent>
      </SectionContent>
    </SectionContainer>
  );
};

export default Lottery;
